export const API_BASE_URL = (import.meta.env.VITE_API_URL || 'http://127.0.0.1:18081').replace(/\/$/, '');

let productRequest;

export function getProducts() {
  if (!productRequest) {
    productRequest = fetch(`${API_BASE_URL}/api/products`)
      .then(async (response) => {
        if (!response.ok) throw new Error('Data master produk tidak dapat dimuat.');
        const data = await response.json();
        if (!Array.isArray(data)) throw new Error('Format data master produk tidak valid.');
        return data.map((product) => ({
          ...product,
          slump_default: product.slump_default?.replace('Â±', '±'),
        }));
      })
      .catch((error) => {
        productRequest = undefined;
        throw error;
      });
  }
  return productRequest;
}

export function getProductPath(product) {
  return `/produk-layanan/detail/${product.id}`;
}

export function getProductImage(product) {
  if (product?.image_url) {
    if (/^https?:\/\//.test(product.image_url)) return product.image_url;
    return `${API_BASE_URL}${product.image_url.startsWith('/') ? '' : '/'}${product.image_url}`;
  }
  return '/reference-images/ready-mix.webp';
}

export function formatProductPrice(price, locale = 'id-ID') {
  const value = Number(price);
  return Number.isFinite(value) && value > 0
    ? `Rp ${value.toLocaleString(locale)}`
    : 'Hubungi sales';
}
